export default __webpack_public_path__ + "static/media/8.c50383a5.jpg";